<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 9L12.5 14.5L7 9" class="stroke-current" />
  </svg>
</template>
